import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlertinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 10v5m0 3v1m.894-16.211l9.382 18.764A1 1 0 0 1 21.382 23H2.618a1 1 0 0 1-.894-1.447l9.382-18.764a1 1 0 0 1 1.788 0z",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgAlertinline;
